import { ref } from "vue";
import { defineStore } from "pinia";

import useGatewayApi from "@/composables/useGatewayApi";
import { TranslationItem } from "@/types/translationItem";

export const useTranslationStore = defineStore("translation", () => {
  const translations = ref< Record<string, any> >(  {})
  const translationItems = ref<TranslationItem[]>([])  // Raw data with ids
  const loading = ref(false)
  const gatewayApi = useGatewayApi();


  async function setTranslations  () {
    const result =  await gatewayApi.get("api/v1/core/admin/translations");
    translationItems.value = result  // Store raw data
    const locales = ['isl', 'pl', 'en']

    for (const locale of locales) {
      translations.value[locale] = result.reduce((acc: Record<string, string>, cur: TranslationItem) => {
        acc[cur.name_Identitfier] = cur[locale]
        return acc
      }, {} as Record<string, string>)
    }

  };

  async function addTranslation(model: any) {
    return gatewayApi.post("api/v1/core/admin/translations", model);
  }

  async function updateTranslation(model: any) {
    return gatewayApi.put("api/v1/core/admin/translations", model);
  }

  async function deleteTranslation(model: any) {
    return gatewayApi.del("api/v1/core/admin/translations", model);
  }

  return {
    translations,
    translationItems,
    loading,
    // action
    setTranslations,
    addTranslation,
    updateTranslation,
    deleteTranslation,

  };
});
